import { FC } from 'react';
import paulinaAvatar from '@assets/images/paulina-avatar.jpg';
import { V4 } from '@components/v4';

/**
 * Header del chat de Paulina (avatar + nombre + borrar + cerrar), compartido por
 * el panel desktop y el bottom-sheet móvil. Emoji nativo prohibido en chrome de UI
 * (DESIGN.md) → iconos SVG para borrar y cerrar.
 */

interface PaulinaChatHeaderProps {
  busy: boolean;
  emptyConversation: boolean;
  onClear: () => void;
  onClose: () => void;
}

export const PaulinaChatHeader: FC<PaulinaChatHeaderProps> = ({ busy, emptyConversation, onClear, onClose }) => (
  <div className="flex items-center justify-between bg-[#253746] px-4 py-3 text-[#ffffff]">
    <div className="flex items-center gap-3">
      <img src={paulinaAvatar} alt="Paulina" className="h-9 w-9 rounded-full border-2 border-[#4298B5] object-cover" />
      <div>
        <p className="font-semibold leading-tight">Paulina</p>
        <p className="text-xs opacity-80">Asistente de Plick</p>
      </div>
    </div>
    <div className="flex items-center gap-1">
      <button
        type="button"
        aria-label="Borrar conversación"
        title="Borrar conversación"
        className="rounded p-1.5 opacity-80 hover:opacity-100 disabled:opacity-40"
        disabled={busy || emptyConversation}
        onClick={onClear}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7"
            stroke={V4.white}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M10 11v6M14 11v6" stroke={V4.white} strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </button>
      <button
        type="button"
        aria-label="Cerrar chat"
        className="rounded p-1.5 opacity-80 hover:opacity-100"
        onClick={onClose}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke={V4.white} strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  </div>
);
